export const TasksDateFilterEnum = {
  CREATED_AT: {
    key: 1,
    value: "created_at",
    label: "created-at",
  },
  UPDATED_AT: {
    key: 2,
    value: "updated_at",
    label: "updated-at",
  },
  START_DATE: {
    key: 3,
    value: "start_date",
    label: "start-date",
  },
  DUE_DATE: {
    key: 4,
    value: "due_date",
    label: "due-date",
  },
};